import { z } from 'zod';

import { ContractStatusSchema } from './contract-status';

export const ContractSchema = z.object({
  id: z.string(),
  assetId: z.string(),
  assetName: z.string(),
  startDate: z.date().optional(),
  endDate: z.date().optional(),
  boltTier: z.string().optional(),
  status: ContractStatusSchema.optional(),
});

export type Contract = z.infer<typeof ContractSchema>;
